import { useState } from 'react'
import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorDeleteDialog } from '../components/processor-delete-dialog'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { AirwallexConfigurationCard } from './components/airwallex-configuration-card'
import { AirwallexDescriptorCard } from './components/airwallex-descriptor-card'
import { AirwallexFeaturesCard } from './components/airwallex-features-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface AirwallexProcessorDetailsPageProps {
    processor: ProcessorDetails
}

export const AirwallexProcessorDetailsPage = ({ processor }: AirwallexProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader
                type="airwallex"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} testModeWarningKey="airwallexTestModeWarning" />
            <ProcessorMetricsCard processor={processor} />
            <AirwallexConfigurationCard processor={processor} />
            <AirwallexDescriptorCard processor={processor} />
            <ProcessorPaymentMethodsCard processor={processor} />
            <AirwallexFeaturesCard />
        </>
    )
}

